import { isValidNumber } from 'libphonenumber-js';

// Check that the input number is a valid phone number
const phoneNumberValidation = country => value =>
	value && !isValidNumber(value, country) ? 'Invalid phone number' : undefined;

export default phoneNumberValidation;
